<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fm-title">ACKNOWLEDGEMENTS</h2>
<p class="noindent">The authors and publisher would like to extend their grateful thanks, in no particular order, to the following individuals and organisations for their assistance with the images used in this publication: Robert Mitchell, James Luto, Historic Military Press, US Naval History and Heritage Command, US National Museum of Naval Aviation, US National Archives and Records Administration, National Museum of the US Air Force, United States Air Force, US Navy, and the US Library of Congress.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Acknowledgements.vue?51789b7e